@if (visible) {
  <button (click)="unimpersonate()" class="btn btn-gray">
    {{ 'IMPERSONATE.STOP_IMPERSONATION' | translate }}
  </button>
}
